// extracted by mini-css-extract-plugin
export default {"root":"HoverPopUp_root__j8N5n","isClosed":"HoverPopUp_isClosed__5DP-n","isOpen":"HoverPopUp_isOpen__uir6f"};